import React from 'react';

export default function AuthBrandPanel() {
  return (
    <aside className="insight-auth-brand" aria-label="About INSIGHT">
      <div className="insight-auth-wordmark">INSIGHT
        <p>Structured Qualitative Exploration Framework</p>
      </div>
      <div className="insight-auth-brand-story">
        <div className="insight-auth-rule" aria-hidden="true" />
        <h2>Professional Exploration.<br /><span>Deeper Understanding.</span></h2>
        <p className="insight-auth-description">A clinician-guided, AI-assisted framework for structured qualitative exploration and professional interpretative reporting.</p>
        <ul>
          <li>Structured Client Exploration</li>
          <li>AI-Assisted Qualitative Analysis</li>
          <li>Clinician-Guided Interpretation</li>
        </ul>
      </div>
      <p className="insight-auth-brand-footer">A considered approach to understanding.</p>
    </aside>
  );
}
